import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "react-select";
import FilePreview from "components/Common/previewFile";

import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  ButtonDropdown,
  Modal,
  ModalBody,
  ModalHeader,
  Form,
  Label,
  Input,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SectionCard from "components/Common/SectionCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import TableComponent from "components/Common/TableComponent";
import ReservationList from "components/Common/ReservationListHm";
import ReservationEnCoursList from "components/Common/ReservationEnCoursListHm";
import OperationList from "components/Common/OperationListHm";
import SouscriptionsHmList from "components/Common/SouscriptionsHmList";
import DocumentHm from "components/Common/DocumentHm";
import DocumentFusionHm from "components/Common/DocumentFusionHm";
import Config from "config";
import DeleteButton from "components/Common/DeleteButtonShow";
import LastModificationAlertShow from "components/Common/AlertShow";
import ReactInputMask from "react-input-mask";

const ContactDetail = () => {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [modal_1, setModal_1] = useState(false);
  const [modal_2, setModal_2] = useState(false);
  const [modal_3, setModal_3] = useState(false);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("auth_token_" + api);
  const [contactsData, setInvestisseursData] = useState([]);
  const [reservationData, setReservationData] = useState([]);
  const [operationData, setOperationData] = useState([]);
  const [souscriptionsData, setSouscriptionsData] = useState([]);
  const [documentData, setDocumentData] = useState([]);
  const [documentFusionData, setDocumentFusionData] = useState([]);
  const [reservationEnCoursData, setReservationEnCoursData] = useState([]);
  const [btnsecondary1, setBtnsecondary1] = useState(false);
  const [docData, setDocData] = useState();
  const [docId, setDocId] = useState("");
  const [selectedCategories, setSelectedCategorie] = useState();
  const handleCategorieChange = (e) => {
    setSelectedCategorie(e);
  };

  const [selectedType, setSelectedType] = useState();
  const handleTypeChange = (e) => {
    setSelectedType(e);
  };
  const [selectedNom, setSelectedNom] = useState();
  const [selectedFichier, setSelectedFichier] = useState();

  const handleFileChange = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      setSelectedFichier(newFile);
    } else {
      setSelectedFichier(null);
      console.log("Aucun fichier sélectionné");
    }
  };
  const [selectedComment, setSelectedComment] = useState("");
  // New
  const [newCategories, setNewCategorie] = useState("");
  const [newType, setNewType] = useState("");
  const [newNom, setNewNom] = useState("");
  const [newFichier, setNewFichier] = useState("");
  const [newComment, setNewComment] = useState("");

  const handleNewCategorieChange = (e) => {
    setNewCategorie(e);
  };

  const handleNewTypeChange = (e) => {
    setNewType(e);
  };

  const handleNomChange = (e) => {
    setNewNom(e.target.value);
  };

  const handleNewFileChange = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      setNewFichier(newFile);
    } else {
      setNewFichier(null);
      console.log("Aucun fichier sélectionné");
    }
  };

  //meta title
  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage
  const [wait, setWait] = useState(1000);
  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  const handleDropDownActionsClick = async (action) => {
    switch (action.action) {
      case "form_dossier_souscription":
        toast.success(
          "Redirection vers la création de souscription en cours ..."
        );
        navigate(
          `${backUrl}/${action.controlleur}/${action.action}/${action.params.investisseur_id}`
        );
        break;
      case "creation_one_user":
        try {
          const response = await fetch(
            `https://www.fluxod.com/${api}/contacts/creation_one_user?investisseur_id=${id}`,
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({}),
            }
          );
          if (response.ok) {
            console.log("POST request successful");
            const responseData = await response.json();
            toast.success(responseData?.message);
          } else {
            console.error("POST request failed");
            toast.error("Une erreur s'est produite");
          }
        } catch (error) {
          console.error("An error occurred", error);
          toast.error("Une erreur s'est produite");
        }
        break;
      case "create_user_from_contact":
        try {
          const response = await fetch(
            `https://www.fluxod.com/${api}/${action.controller}/create_user_from_contact?contact_id=${action.params.contact_id}`,
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({}),
            }
          );
          if (response.ok) {
            console.log("POST request successful");
            const responseData = await response.json();
            toast.success(responseData?.message);
          } else {
            console.error("POST request failed");
            const responseData = await response.json();

            toast.error(responseData?.fx_user_validation?.join(", "));
          }
        } catch (error) {
          console.error("An error occurred", error);
          toast.error("Une erreur s'est produite");
        }
        break;
      default:
        toast.error("Aucune action configurée");
        break;
    }
  };
  document.title = "Contacts | DETAILS";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            onClick={() => handleTabClick("details")}
          >
            Détails contacts
          </NavLink>
        </NavItem>
      </Nav>
    );
  };
  useEffect(() => {
    const getData = async () => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/contacts/${id}/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 403) {
          navigate(`${backUrl}/forbidden`);
        }
        if (response.status === 500) {
          navigate(`${backUrl}/error`);
        }
        if (response.status === 203) {
          navigate(`${backUrl}/error404`);
        }
        if (response.status === 401) {
          localStorage.removeItem("auth_token_" + api);
          localStorage.removeItem("authUser_" + api);
          localStorage.removeItem("sideBar_" + api);
          navigate(`${backUrl}/login`);
          window.location.reload(false);
        }

        // if (!response.ok) {
        //   localStorage.removeItem("auth_token_"+api);
        //   localStorage.removeItem("authUser_"+api);
        //   localStorage.removeItem("sideBar_"+api);
        //   history("/backoffice_test/login");
        //   window.location.reload(false);
        //   throw new Error(`Request failed with status: ${response.status}`);
        // }

        const contactsData = await response.json();
        setInvestisseursData(contactsData);
      } catch (error) {
        // Handle any other errors that might occur during the fetch
        console.error("Error fetching data:", error.message);
      }
    };

    const fetchData = async () => {
      try {
        await getData();
        console.log("Sorti", reservationData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();

    if (localStorage.getItem("key") === "true") {
      toast.success("Mise à jour réussie");
      localStorage.setItem("key", "false");
    }
  }, []);
  useEffect(() => {
    if (wait === 0) {
      setLoading(false);
    }
  }, [wait]);

  let linkState = { active: "" };

  if (activeTab == "details") {
    linkState.active = "details";
  } else if (activeTab == "contact") {
    linkState.active = "contact";
  } else {
    linkState.active = "details";
  }

  function extractSegment(url) {
    const baseUrl = `${backUrl}/`;
    const editSegment = "/edit";

    // Check if the URL starts with the base URL and ends with the edit segment
    if (url.startsWith(baseUrl) && url.endsWith(editSegment)) {
      // Extract the part of the URL between base URL and edit segment
      const start = baseUrl.length;
      const end = url.length - editSegment.length;
      return url.substring(start, end);
    }

    return null;
  }
  const lastId = localStorage.getItem("lastId");
  const previousPath = localStorage.getItem("previousPath_" + api);

  const extractedText = extractSegment(previousPath);
  console.log(extractedText);
  return (
    <React.Fragment>
      <div className="page-content" style={{ fontFamily: "sans-serif" }}>
        {previousPath == `${backUrl}${extractedText}/edit` ? (
          <LastModificationAlertShow path={extractedText} />
        ) : null}
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-0 card-title flex-grow-1"
                      style={{ fontWeight: "bold", display: "flex" }}
                    >
                      <Link
                        to={`${backUrl}${contactsData?.link_partenaire}`}
                        style={{
                          color: "#555B21",
                          textDecoration: "underline !important",
                        }}
                      >
                        {contactsData?.sil_partenaire}
                      </Link>{" "}
                      <i className="bx bx-caret-right"></i>{" "}
                      {!loading ? (
                        contactsData.sil
                      ) : (
                        <>
                          <span
                            className="placeholder col-3"
                            style={{ height: "1em" }}
                          ></span>
                        </>
                      )}
                    </h5>
                  </div>

                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end">
                      {contactsData?.can_edit ? (
                        <Link
                          to={`${backUrl}/contacts/${id}/edit`}
                          state={linkState}
                          className="btn btn-sm btn-primary"
                        >
                          <i className="bx bx-edit-alt"></i>Modifier
                        </Link>
                      ) : null}
                      {contactsData?.can_destroy ? (
                        <>
                          &nbsp; &nbsp;
                          <DeleteButton
                            url={`https://www.fluxod.com/${api}/contacts/${id}`}
                          />
                        </>
                      ) : null}
                      {contactsData?.actions?.length > 0 ? (
                        <>
                          &nbsp; &nbsp;
                          <Dropdown
                            isOpen={btnsecondary1}
                            toggle={() => setBtnsecondary1(!btnsecondary1)}
                          >
                            <DropdownToggle
                              tag="button"
                              className="btn btn-sm btn-secondary"
                            >
                              Actions <i className="mdi mdi-chevron-down" />
                            </DropdownToggle>
                            <DropdownMenu>
                              {contactsData?.actions.map((value, index) => (
                                <>
                                  <DropdownItem
                                    onClick={() =>
                                      handleDropDownActionsClick(value.action)
                                    }
                                  >
                                    {value.label}
                                  </DropdownItem>
                                </>
                              ))}
                            </DropdownMenu>
                          </Dropdown>
                        </>
                      ) : null}
                    </div>
                  </div>
                </CardBody>
                {CustomNavTabs()}
                <CardBody>
                  {activeTab === "details" && (
                    <div>
                      {!loading ? (
                        <>
                          <Row>
                            {contactsData?.detail_contact?.identification ? (
                              <>
                                <Col sm="6">
                                  <IdentificationCard
                                    title="Identification"
                                    details={
                                      contactsData?.detail_contact
                                        ?.identification
                                    }
                                    ids={
                                      backUrl + contactsData?.link_partenaire
                                    }
                                  />
                                </Col>
                                <Col sm="6">
                                  <IdentificationCard
                                    title="Renseignements Divers"
                                    details={
                                      contactsData?.detail_contact
                                        ?.renseignements_divers
                                    }
                                  />
                                </Col>
                              </>
                            ) : (
                              ""
                            )}
                          </Row>
                          <Row>
                            <Col sm="12">
                              <CardTitle
                                tag="h5"
                                style={{ paddingBottom: "10px" }}
                              >
                                Adresses
                              </CardTitle>
                              <TableComponent
                                header={
                                  contactsData?.detail_contact
                                    ?.adresses_postales?.Adresses.header
                                }
                                data={
                                  contactsData?.detail_contact
                                    ?.adresses_postales?.Adresses.data
                                }
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col sm="6">
                              <CardTitle
                                tag="h5"
                                style={{ paddingBottom: "10px" }}
                              >
                                Emails
                              </CardTitle>
                              <TableComponent
                                header={
                                  contactsData?.detail_contact?.adresses_email
                                    ?.Emails.header
                                }
                                data={
                                  contactsData?.detail_contact?.adresses_email
                                    ?.Emails.data
                                }
                              />
                            </Col>
                            <Col sm="6">
                              <CardTitle
                                tag="h5"
                                style={{ paddingBottom: "10px" }}
                              >
                                Numéros
                              </CardTitle>
                              <TableComponent
                                header={
                                  contactsData?.detail_contact
                                    ?.numeros_de_telephone?.Téléphones.header
                                }
                                data={
                                  contactsData?.detail_contact
                                    ?.numeros_de_telephone?.Téléphones.data
                                }
                              />
                            </Col>
                          </Row>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      {/* <ToastContainer /> */}
    </React.Fragment>
  );
};

export default ContactDetail;
